import React from "react";
import SelectorGridGroupContainer from "./SelectorGridGroupContainer";
import SelectorGridGroup from "./SelectorGridGroup";
import SelectorGridItem from "./SelectorGridItem";
import { camelToName } from "../../../helpers/stringHelpers";

const SelectorGridList = props => {
  const {
    atoms,
    config,
    onAtomSelect,
    currentSubStepSelectedAtom,
    getIconImage,
    checkEnabledLevel
  } = props;

  const renderSelectorGridGroups = (atomsTypes, typeName) => {
    return atomsTypes.map((atomType, index) => {
      return (
        <SelectorGridGroup key={atomType.name}>
          {atomType.list ? (
            atomType.list.map(atom => {
              const selected = currentSubStepSelectedAtom.alias === atom.alias;
              const disabled = !checkEnabledLevel(atom, typeName);
              return (
                <SelectorGridItem
                  disabled={disabled}
                  img={getIconImage(atom.alias)}
                  selected={selected}
                  key={atom.alias + "-" + index}
                  atom={atom}
                  onAtomSelect={() => onAtomSelect(atom, atomType.name, config.link)}
                />
              );
            })
          ) : (
            <div>loading</div>
          )}
        </SelectorGridGroup>
      );
    });
  };

  const renderSelectorGridGroupContainers = () => {
    return atoms.map(type => {
      return (
        <SelectorGridGroupContainer
          key={type.name}
          showName={config.showTypes}
          name={camelToName(type.name)}
        >
          {renderSelectorGridGroups(type.atoms, type.alias)}
        </SelectorGridGroupContainer>
      );
    });
  };

  return (
    <div className="selector-grid-list">
      {atoms
        ? renderSelectorGridGroupContainers()
        : "nessun elemento da mostrare"}
    </div>
  );
};

export default SelectorGridList;
